import { Language } from '@shared/app/scripts/services/language';

/**
 * Shows the <privacy-policy> component
 */
angular.module('gateApp').component('privacyPolicy', {
  template: require('./privacy-policy.html').default,
  controller: function ($sce: ng.ISCEService, language: Language) {
    const $ctrl = this;

    $ctrl.currentLanguage$ = language.current$;

    $ctrl.content = {
      // legal i18n list
      'nl-nl': $sce.trustAsHtml(require('./nl-nl.html').default),
      'en-gb': $sce.trustAsHtml(require('./en-gb.html').default),
    };
  },
});
